import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { SharedService } from 'src/app/shared/shared.service';
import { AppConstants } from 'src/app/config.service';
import { finalize } from 'rxjs/operators';
import { ExceptionHandlingService } from 'src/app/shared/exception-handling.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastService, IMyOptions } from 'ng-uikit-pro-standard';


@Component({
  selector: 'delete-selection-modal',
  templateUrl: './delete-selections-modal.component.html'
})
export class DeleteSelectionsModalComponent implements OnInit {

  @Input() selections: any;
  @Output() emitSuccess = new EventEmitter<any>();
  error: any = {}

  constructor(
    private service: SharedService,
    private appConstants: AppConstants,
    private errorService: ExceptionHandlingService,
    private toastr: ToastService,
    private translate: TranslateService
  ) { }

  ngOnInit() {}

  datePickerOptions: IMyOptions = {
    dateFormat: 'mmm-dd-yyyy',
    closeAfterSelect: true,
    editableDateField:false
  };

  @ViewChild('deleteSelectionsModal', { static: true }) deleteSelectionsModal: any;
  action: any = {}
  ngOnChanges() {
    if (this.selections && this.selections.selectedSelections && this.selections.selectedSelections.length) {
      this.error = {};
      this.action = {};
      this.deleteSelectionsModal.show();
    }
  }

  selectionsModalLoader : boolean = false
  deleteSelections() {

    let modelSchema = {}
    const criteria = {};
    if (this.selections.selection.selectionYear) {
      let selectedYear = new Date(this.selections.selection.selectionYear);
      criteria["selectionYear"] = (selectedYear).getFullYear();
    }
    if (this.selections.selection.region)
      criteria["regionId"] = this.selections.selection.region.id

    if (this.selections.selection.customerDisplayName)
      criteria["customerDisplayName"] = this.selections.selection.customerDisplayName

    if (this.selections.selection.name)
      criteria["name"] = this.selections.selection.name

    if (this.selections.selection.status)
      criteria["status"] = this.selections.selection.status
    criteria["pageNumber"] = this.selections.pageInfo.currentPage;
    criteria["pageSize"] = this.selections.pageInfo.itemsPerPage;
    criteria["isPaging"] = true;
    criteria['applicantComponentSelectionIds'] = this.selections.selectedSelections.map(ss => { return ss.id })
    modelSchema["criteria"] = criteria;
    modelSchema["selectAll"] = this.selections.selectAllOption.isAllSelected;


    this.selectionsModalLoader = true;
    this.service
      .put(this.appConstants.endPoints.certificatesEndPoint + 'critical-components/applicant-component-selections/batch-operations/delete', {}, modelSchema)
      .pipe(finalize(() => {
        this.selectionsModalLoader = false;
      })).subscribe(data => {
        this.deleteSelectionsModal.hide();
        this.emitSuccess.emit(true)
        this.toastr.success(this.translate.instant('administration_successfullyDeletedSelections_label'));
      },
        error => {
          this.errorService.errorHandling(error).then(res => {
            this.error = res;
          });
        })
  }
 
}